/**
 * AI Chat Feature - Main Export
 */

import { aiChatService } from './services/aiChatService.js';
import { contextService } from './services/contextService.js';

export const initAiChatServices = () => {
  contextService.init();
  aiChatService.init();
  console.log('AI Chat services initialized');
};

export const aiChat = {
  // Service instances
  service: aiChatService,
  context: contextService,

  // Convenience methods
  async startConversation(userId, tripId, options = {}) {
    return aiChatService.startConversation(userId, tripId, options);
  },

  async sendMessage(conversationId, message, userId) {
    return aiChatService.handleUserMessage({
      payload: { conversationId, message, userId }
    });
  },

  async changeModel(conversationId, newModel, userId) {
    return aiChatService.handleModelChange({
      payload: { conversationId, newModel, userId }
    });
  },

  getAvailableModels() {
    return aiChatService.getAvailableModels();
  },

  getConversationHistory(userId, tripId = null) {
    return aiChatService.getConversationHistory(userId, tripId);
  },

  async endConversation(conversationId) {
    return aiChatService.endConversation(conversationId);
  }
};

// Export components
export { default as ChatInterface } from './components/ChatInterface/ChatInterface.jsx';

// Export services
export { aiChatService, contextService };

export default aiChat;